  <h2 mat-dialog-title>
    <span *ngIf="data.moduleName!='Portal'" class="groupIcon"><mat-icon>touch_app</mat-icon></span>
    <span *ngIf="data.moduleName=='Portal'" class="groupIconPortal"><mat-icon>touch_app</mat-icon></span>
    <p *ngIf="data && !data.touch">Add Note</p>
    <p *ngIf="data && data.touch && data.touch.touchID>0">Update Note </p>        
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
    
  </h2>

<mat-dialog-content>
  <form [formGroup]="myTouchesForm" class="fix-mat-form-field">    
    <div class="divideCol">
        <div class=" dflex">
          <mat-form-field>
            <mat-label>Note Type</mat-label>
            <mat-select  formControlName="touchtype" matInput (selectionChange)="DropDownActivityType($event)">
              <mat-option *ngFor="let rel of TouchesType" [value]="rel.touchTypeID">
                {{rel.touchName}}
              </mat-option>
           </mat-select>            
          </mat-form-field>  

          <button  *ngIf="data.moduleName!='Portal'" mat-icon-button color="primary"
           (click)="openDialogAddWithRef()" matTooltip="Add Note Type"> 
           <mat-icon>add</mat-icon> 
          </button>

        </div>        

    </div>


    <div class="divideCol">
      <mat-form-field>
        <mat-label>Status</mat-label>
        <mat-select formControlName="touchstatus" matInput>
          <mat-option *ngFor="let rel of statusList" [value]="rel.touchStatusID">
            {{rel.touchStatusName}}
          </mat-option>
       </mat-select>   

        <!-- <mat-select value="" formControlName="touchstatus">
          <mat-option value="1">Completed</mat-option>
          <mat-option value="2">Unavailable </mat-option>
          <mat-option value="3">Left Message</mat-option>
          <mat-option value="4">Cancelled</mat-option>
          <mat-option value="5">Other</mat-option>
        </mat-select> -->
      </mat-form-field> 

      <div *ngIf="showStatusButton==true">     
      <button *ngIf="data.moduleName!='Portal'" mat-icon-button color="primary"
           (click)="openDialogAddStatusWithRef()" matTooltip="Add Status"> 
           <mat-icon>add</mat-icon> 
          </button>
     </div>

     </div>

    <div class="divideCol">     
      <mat-checkbox #datetimecheckbox [(ngModel)]="showDateTime" (change)="showDateTimeSelect($event)">Add date & time</mat-checkbox>    
   </div>
    
   <ng-container *ngIf="showDateTime==true">     
 
    <div class="p10" >

      <div class="divideCol">
        <div class="left blk">         
            <mat-form-field appearance="legacy" >
              <mat-label>Start Date</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="startDate" readonly>
              <span class="dateHolder" >
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </span>
              
            </mat-form-field>
        </div>
  
        <div class="right blk">         
          <mat-form-field appearance="legacy">
            <mat-label>Start Time</mat-label>
            <input matInput [ngxTimepicker]="toggleTimepicker" [disableClick]="true" readonly
            formControlName="startTime">
            <span class="dateHolder" >
              <ngx-material-timepicker-toggle [for]="toggleTimepicker"></ngx-material-timepicker-toggle>
            <ngx-material-timepicker #toggleTimepicker ></ngx-material-timepicker>
            </span>
          </mat-form-field>
      </div>
  
      </div>
  
       <div class="divideCol">
        <div class="left blk">         
            <mat-form-field appearance="legacy">
              <mat-label>End Date</mat-label>
              <input matInput [matDatepicker]="picker1" formControlName="touchDate" readonly>
              <span class="dateHolder" >
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </span>
            </mat-form-field>
        </div>
  
        <div class="right blk">         
          <mat-form-field appearance="legacy">
            <mat-label>End Time</mat-label>
            <input matInput [ngxTimepicker]="toggleTimepicker1" [disableClick]="true" readonly
            formControlName="touchTime">
            <span class="dateHolder" >
              <ngx-material-timepicker-toggle [for]="toggleTimepicker1"></ngx-material-timepicker-toggle>
              <ngx-material-timepicker #toggleTimepicker1 ></ngx-material-timepicker>
            </span>
          </mat-form-field>
      </div>
       
      </div> 

    </div>

  </ng-container>

    <mat-form-field>
      <mat-label>Notes</mat-label>
      <textarea class="noteTextarea" matInput formControlName="touchnotes"
                cdkTextareaAutosize
                ></textarea>
    </mat-form-field>

    <mat-checkbox *ngIf="data.moduleName!='Portal'"
    color="primary" formControlName="viewOn">Show On Portal</mat-checkbox>

  </form>
  </mat-dialog-content>
  
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button *ngIf="data && !data.touch" mat-flat-button class="calltoaction" [disabled]="myTouchesForm.invalid || !myTouchesForm.dirty" type="submit"
      (click)="SaveTouchesDetail(myTouchesForm.value)" color="primary">
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
      Save
    </button>  
    <button *ngIf="data && data.touch && data.touch.touchID>0" mat-flat-button class="calltoaction" [disabled]="myTouchesForm.invalid || !myTouchesForm.dirty" type="submit"
      (click)="SaveTouchesDetail(myTouchesForm.value)" color="primary">
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
      Update
    </button>   
  </mat-dialog-actions>



  

  




